'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('react');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var cancel = require('./cancel-2161b174.js');

var ChipContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n", "\n  border-radius: 5px;\n  display: inline-flex;\n  gap: 4px;\n  align-items: center;\n  cursor: ", ";\n  &:hover {\n    ", "\n  }\n"], ["\n",
    "\n  border-radius: 5px;\n  display: inline-flex;\n  gap: 4px;\n  align-items: center;\n  cursor: ", ";\n  &:hover {\n    ",
    "\n  }\n"])), function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return (isActive ? "\n  border: 2px solid " + theme.colors.primary + ";\n  padding: 7px 12px;\n" : "\n  border: 1px solid " + theme.colors.fontColor + ";\n  padding: 8px 13px;\n");
}, function (_a) {
    var isClickable = _a.isClickable;
    return (isClickable ? 'pointer' : 'default');
}, function (_a) {
    var isClickable = _a.isClickable, theme = _a.theme;
    return (isClickable && "\n      border: 2px solid " + theme.colors.primary + ";\n      padding: 7px 12px;\n    ");
});
var ChipText = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: ", ";\n  font-family: ", ";\n  color: ", ";\n  ", "\n"], ["\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: ", ";\n  font-family: ", ";\n  color: ", ";\n  ",
    "\n"])), function (_a) {
    var isActive = _a.isActive;
    return (isActive ? '500' : '400');
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return (isActive ? theme.colors.primary : theme.colors.fontColor);
}, function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return (isActive ? "\n  font-weight: 500;\n  color: " + theme.colors.primary + ";\n  " : "\n  font-weight: 400;\n  color: " + theme.colors.fontColor + ";\n  ");
});
var StyledCancel = styled__default(cancel.Cancel)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  cursor: pointer;\n  &:hover {\n    outline: -webkit-focus-ring-color auto 5px;\n  }\n"], ["\n  cursor: pointer;\n  &:hover {\n    outline: -webkit-focus-ring-color auto 5px;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;

exports.ChipContainer = ChipContainer;
exports.ChipText = ChipText;
exports.StyledCancel = StyledCancel;
